const routes = {
    path: 'testemunhas',
    name: 'MapaParceiros_Testemunha',
    component: () => import('./lista/ListaTestemunhas.vue'),
    meta: {
        rules: ['MAPAPARC-PES-00'],
    },
};

export default routes;